import Vue from 'vue';
import Toasted from 'vue-toasted';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import axios from 'axios';
import store from './store';
import VueSweetalert2 from 'vue-sweetalert2';
import VueGoodTablePlugin from 'vue-good-table';
import ReadMore from 'vue-read-more';
import VueLazyLoad from 'vue-lazyload';
import excel from 'vue-excel-export';
import $ from 'jquery'

import 'vue-good-table/dist/vue-good-table.css'
import '@/assets/icons-font/style.css';
import filters from '@/mixins/filters';

const sweetAlertOptions = {
	customClass: {
		popup: 'cot-sweet-alert',
		cancelButton: 'btn btn-white-border',
		confirmButton: 'btn btn-warning d-flex align-items-center'
	},
	position: 'center'
}

axios.interceptors.response.use(
	response => response,
	error => {
		store.dispatch("showLoader", { show: false });
		if (!error.response) {
			// store.commit()
		} else {
			if ( !error.response.config.url.includes('/user/login') && error.response.status == 403) {
				delete axios.defaults.headers.common['Authorization'];
				if (store.getters.userRole == "Admin") {
					store.dispatch('admin/signOut').then(
						() => {
							window.location = '/ingresar/admin';
						}
					)
				} else {
					store.dispatch('client/signOut').then(
						() => {
							window.location = '/ingresar';
						}
					)
				}
			} else {
				if (error.response.status != 403) {
					store.dispatch('showMessage', { action: 'error', message: error.response.data.message || error.errors })
				}
			}
		}

		return Promise.reject(error.response);
	}
);

if (store.state.token) {
	axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;
}

moment.locale('es');

Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
Vue.prototype.$eventHub = new Vue();

/* Import Extra modules */
Vue.use(VeeValidate);
Vue.use(VueSweetalert2, sweetAlertOptions);
Vue.use(VueGoodTablePlugin);
Vue.use(ReadMore);
Vue.use(VueLazyLoad)
Vue.use(excel)
Vue.use(Toasted)

/* Directiva para tooltips */
Vue.directive('tooltip', function (el, binding) {
	$(el).tooltip({
		title: binding.value,
		placement: "auto",
		trigger: 'hover'
	})
})

Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			// here I check that click was outside the el and his children
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function (el) {
		document.body.removeEventListener('click', el.clickOutsideEvent)
	},
});

Vue.filter('capitalize', filters.filters.capitalize);
Vue.filter('currency', filters.filters.currency);
Vue.filter('date', filters.filters.date);
Vue.filter('fullname', filters.filters.fullname);
Vue.filter('status', filters.filters.status);
Vue.filter('getTimeString', filters.filters.getTimeString);
